import { React, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import "./FlightInput.css";

function FlightInput({ postRoute, onSuccess }) {
  const { register, handleSubmit } = useForm();
  const [errorMessage, setErrorMessage] = useState(null);
  const { trip_id } = useParams();
  // const navigate = useNavigate();

  const onFormSubmit = async (data) => {
    try {
      const flightData = {
        ...data,
        trip_id: trip_id,
      };
      const response = await axios.post(postRoute, flightData);
      console.log("Response from server:", response);

      // Notify parent of success
      if (onSuccess) onSuccess("Flight added successfully");
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      setErrorMessage(
        err.response?.data?.error || "An unexpected error occurred."
      );
    }
  };

  const onErrors = (errors) => console.error(errors);

  return (
    <>
      <div className="flight-input-container">
        <div className="planner-title">
          <p className="planner-heading">New Flight</p>
          <button className="icon-style">
            {/* Optional icon, e.g., <CloseIcon /> */}
          </button>
        </div>

        <form
          className="flight-detail"
          onSubmit={handleSubmit(onFormSubmit, onErrors)}
        >
          <div className="planner-label-container">
            <label className="planner-label">Departure Airport:</label>
            <input
              type="text"
              {...register("departure_airport")}
              placeholder="Departure airport"
              className="planner-text"
            />
          </div>

          <div className="planner-label-container">
            <label className="planner-label">Arrival Airport:</label>
            <input
              type="text"
              {...register("arrival_airport")}
              placeholder="Arrival airport"
              className="planner-text"
            />
          </div>

          <div className="planner-label-container">
            <label className="planner-label">Flight Number:</label>
            <input
              type="text"
              {...register("flight_number")}
              placeholder="Flight number"
              className="planner-text"
            />
          </div>

          <div className="planner-label-container">
            <label className="planner-label">Airline:</label>
            <input
              type="text"
              {...register("airline")}
              placeholder="Airline"
              className="planner-text"
            />
          </div>

          <div className="planner-label-container">
            <label className="planner-label">Departure Time:</label>
            <input
              type="datetime-local"
              {...register("departure_time")}
              className="planner-text"
            />
          </div>

          <div className="planner-label-container">
            <label className="planner-label">Arrival Time:</label>
            <input
              type="datetime-local"
              {...register("arrival_time")}
              className="planner-text"
            />
          </div>

          {errorMessage && <p className="error">{errorMessage}</p>}

          <button type="submit" className="add-button">
            Save Flight
          </button>
        </form>
      </div>
    </>
  );
}

export default FlightInput;
